import { useCallback, useEffect, useRef } from 'react';

import _ from 'lodash';

import { ACTIVITY_EVENTS, ACTIVITY_THROTTLE_MS, IDLE_TIMEOUT_MS } from 'constants/presence';

const useActivityTracking = () => {
  const lastActivityTimeRef = useRef(Date.now());

  const onActivity = useRef(
    _.throttle(() => {
      lastActivityTimeRef.current = Date.now();
    }, ACTIVITY_THROTTLE_MS),
  ).current;

  useEffect(() => {
    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, onActivity);
    });

    return () => {
      ACTIVITY_EVENTS.forEach(event => {
        document.removeEventListener(event, onActivity);
      });

      onActivity.cancel();
    };
  }, [onActivity]);

  const isUserActive = useCallback(
    () => Date.now() - lastActivityTimeRef.current < IDLE_TIMEOUT_MS,
    [],
  );

  return { isUserActive };
};

export default useActivityTracking;
